import { render, staticRenderFns } from "./SingleNetworkView.vue?vue&type=template&id=52eae60e&lang=pug"
import script from "./SingleNetworkView.vue?vue&type=script&lang=ts"
export * from "./SingleNetworkView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports